// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2ROq4","title":"Header_title__17xcV","side":"Header_side__VDLB9"};